<template>
  <b-table-lite small striped borderless outlined head-variant="dark" stacked="md" :table-variant="tableVariant" :fields="fields" :items="tableData">
    <template #cell(originalCost)="row" v-if="isAnAdministrator">{{ row.item.originalCost | currency }}</template>
  </b-table-lite>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'underscore';
import { Trip } from '@/model/travel';

@Component({
  filters: {
    currency: (c) => {
      const v = parseFloat(c) || null;
      return null === v ? '' : `$${v.toFixed(2)}`;
    }
  }
})
export default class BookedAirfare extends Vue {
  @Prop({ type: Trip }) trip;
  @Prop({ type: String, default: 'success' }) tableVariant;

  get selectedTrip() {
    return this.trip || {};
  }

  get airfare() {
    return this.selectedTrip.airfare || [];
  }

  get activeUser() {
    return this.$store.getters['userSession/getUser'] || {};
  }

  get isAnAdministrator() {
    return _(this.activeUser.isAnAdministrator).isFunction() ? this.activeUser.isAnAdministrator() : false;
  }

  get fields() {
    const fields = [
      {
        key: 'ticketStatus',
        label: 'Ticket Status'
      },
      {
        key: 'airline',
        label: 'Airline'
      },
      {
        key: 'ticketNumber',
        label: 'Ticket Number'
      },
      {
        key: 'confirmationCode',
        label: 'Confirmation Code'
      }
    ];

    if (this.isAnAdministrator) {
      fields.push({
        key: 'originalCost',
        label: 'Ticket Cost'
      });
    }

    return fields;
  }

  get tableData() {
    return _(this.airfare)
      .chain()
      .sortBy((af) => af.issueDate)
      .map((row) => {
        if (!this.isAnAdministrator) {
          delete row.originalCost;
        }

        return row;
      })
      .value();
  }
}
</script>
